import { render, staticRenderFns } from "./IBKRPortfolioForm.vue?vue&type=template&id=05b07407&scoped=true&"
import script from "./IBKRPortfolioForm.vue?vue&type=script&lang=js&"
export * from "./IBKRPortfolioForm.vue?vue&type=script&lang=js&"
import style0 from "./IBKRPortfolioForm.vue?vue&type=style&index=0&id=05b07407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b07407",
  null
  
)

export default component.exports